import SupportRequestSentDialog from './SupportRequestSentDialog'

export default SupportRequestSentDialog
